var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg_FFFFFF"},[_c('Header',{attrs:{"activeName":_vm.activeName}}),_c('div',{staticStyle:{"height":"900px","width":"100%"}},[_c('Hotmap')],1),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }